import Loader from 'components/Loader';
import { Field, Form, Formik } from 'formik';
import React, { useState } from 'react';
import { addPasswordSchema } from 'utils/validationSchemas';

export const DefaultLoginToggle = (props) => {
	const {
		onlyOneLeft,
		isEnabled,
		signInMethod,
		onUnlink,
		onLink
	} = props;

	const [loading, setLoading] = useState(false)

	const handleAddPassword = (values, actions) => {
		setLoading(true)
		onLink(values.password)
		setLoading(false)
		actions.setSubmitting(false)
	}

	return isEnabled ? (
		<button
			type="button"
			className="rn-button-style--2 mt--20"
			onClick={() => onUnlink(signInMethod.id)}
			disabled={onlyOneLeft}
		>
			Deactivate {signInMethod.id}
		</button>
	) : (
		<div className="contact-form--1 mb--20">
			{loading
				? <Loader />
				: <Formik
				initialValues= {{
					password: '',
					confirmPassword: ''
				}}
				validationSchema= {addPasswordSchema}
				onSubmit={handleAddPassword}
			>
				{({ errors, getFieldProps, handleSubmit, isSubmitting, touched }) => (
				<Form onSubmit={handleSubmit}>

					{touched.password && errors.password ? (<div className="error">{errors.password}</div>) : null}
					<Field required icon='lock' id="password" type="password" placeholder="Add Password" {...getFieldProps('password')} />

					{touched.confirmPassword && errors.confirmPassword && (<span className="error">{errors.confirmPassword}</span>)}
					<Field required id="confirmPassword" type="password" placeholder="Confirm New Password" {...getFieldProps('confirmPassword')} />

				<button className="rn-button-style--2 btn-solid" disabled={isSubmitting} type="submit">
					Link {signInMethod.id}
				</button>
					</Form>
				)}
			</Formik>}
		</div>
	)
}

